module.exports = __webpack_public_path__ + "img/octopus-front.e9507339.png";